import React, { createContext, useReducer, FunctionComponent } from "react";
import { ReducerTypes } from "shared/types/reducerTypes";
import { Challenge } from "shared/types/challenges";
import { User } from "shared/types/user";
import { Solution } from "shared/types/solutions";
import { Errors } from "shared/types/errors";

const initialState: {
  challenges?: Challenge[];
  solutions?: Solution[];
  user?: User;
  userSolutions?: Solution[];
  loadingUser: boolean;
  pageLoading: boolean;
  solutionPage: number;
  notifications: any;
  theme: string;
  solutionsEnd: boolean;
  solutionsCurrentPage: number;
} = {
  challenges: undefined,
  solutions: [],
  solutionPage: 0,
  user: undefined,
  userSolutions: undefined,
  loadingUser: true,
  pageLoading: false,
  notifications: {
    notifications: [],
  },
  theme: "light",
  solutionsEnd: false,
  solutionsCurrentPage: -1,
};

const reducer = (
  state: any,
  { type, payload }: { type: string; payload: { key: string; value: any } }
) => {
  switch (type) {
    //Solutions
    case ReducerTypes.setSolutionsCurrentPage:
      return { ...state, solutionsCurrentPage: payload.value };

    case ReducerTypes.setSolutions:
      return { ...state, solutions: payload.value };

    case ReducerTypes.setSolutionsEnd:
      return { ...state, solutionsEnd: payload.value };

    case ReducerTypes.setSelectedChallangeId:
      return { ...state, selectedChallengeId: payload.value };

    case ReducerTypes.setSelectedChallange:
      return { ...state, selectedChallenge: payload.value };

    //End Solutions

    case ReducerTypes.getTheme:
      return { ...state, theme: payload.value };

    case ReducerTypes.getTopUsers:
      return { ...state, topUsers: payload.value };

    case ReducerTypes.getRecentBadges:
      return { ...state, recentBadges: payload.value };

    case ReducerTypes.getUserBadges:
      return { ...state, badges: payload.value };

    case ReducerTypes.getNotification:
      return { ...state, notifications: payload.value };

    case ReducerTypes.seenNotifications:
      return { ...state, seenNotifications: true };

    case ReducerTypes.setNotification:
      return {
        ...state,
        notifications: { ...state.notifications, notifications: payload.value },
      };

    case ReducerTypes.fetchChallenges:
      return { ...state, challenges: payload.value };

    case ReducerTypes.getUser: {
      return { ...state, user: payload.value, error: undefined };
    }

    case ReducerTypes.getUserSolutions: {
      return { ...state, userSolutions: payload.value };
    }

    case ReducerTypes.removeUser: {
      return { ...state, user: undefined };
    }

    case ReducerTypes.startFetchingUser: {
      return { ...state, loadingUser: true };
    }

    case ReducerTypes.endFetchingUser: {
      return { ...state, loadingUser: false };
    }

    case ReducerTypes.startGlobalLoader: {
      return { ...state, pageLoading: true };
    }

    case ReducerTypes.endGlobalLoader: {
      return { ...state, pageLoading: false };
    }

    case ReducerTypes.sessionExpired: {
      return { ...state, error: Errors.sessionExpired, user: undefined };
    }

    case ReducerTypes.requireLogin: {
      return { ...state, error: Errors.requireLogin, user: undefined };
    }

    case ReducerTypes.unexpectedError: {
      return { ...state, error: Errors.unexpectedError, user: undefined };
    }

    case ReducerTypes.clearError: {
      return { ...state, error: undefined };
    }

    case ReducerTypes.resetUser:
      return { ...state, user: undefined };

    case ReducerTypes.reset:
      return initialState;
    default:
      return state;
  }
};

const AppContext = createContext<any>(initialState);
const { Provider } = AppContext;

const StateProvider: FunctionComponent<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export const AppProvider = StateProvider;
export const AppConsumer = AppContext.Consumer;

export default AppContext;
